<template>
  <ItemListCollectionWrapper
    class="itemListWrapper"
    :collectionModule="$options.PasswordManagerItemCollection"
    :defaultFilters="defaultFilters"
    defaultSortBy="nickname"
    :refreshKey="refreshKey"
    :rowsPerPageLocalStorageKey="$options.rowsPerPageLocalStorageKey"
  >
    <template
      v-slot="slotProps"
    >
      <ItemListPagination
        :columns="columns"
        :currentPageNum="slotProps.currentPageNum"
        :isLoading="slotProps.loading"
        :itemComponent="$options.PasswordManagerItemsListRow"
        :rowsPerPage="slotProps.rowsPerPage"
        :showEmptyState="showEmptyState(slotProps)"
        :sortBy="slotProps.sortBy"
        :sortDirection="slotProps.sortDirection"
        :tableData="slotProps.tableData"
        :totalCount="slotProps.totalCount"
        @pageChange="slotProps.handlePageChange"
        @sortColumn="slotProps.handleSortColumn"
      >
        <template v-slot:toolbar>
          <Toolbar
            :searchTerm="slotProps.getSearchTerm"
            :shouldFocusSearch="slotProps.shouldFocusSearch"
            @triggerSearch="slotProps.handleEnterSearchTerm"
          />
        </template>
        <template v-slot:emptyState>
          <NoSearchResults
            ctaText=" "
            instructions=" "
            :title="`No items${slotProps.showEmptyState ? ' found' : ''}`"
          />
        </template>
      </ItemListPagination>
    </template>
  </ItemListCollectionWrapper>
</template>

<script>
import {
  ItemListPagination,
  NoSearchResults,
  Types,
} from '@jumpcloud/ui-components';
import {
  LocalStorageConsts,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import { passwordManagerItemFieldsLabelMap, passwordManagerItemTypeServerId } from 'client/PasswordManager/PasswordManagerConstants';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import PasswordManagerFilters from 'client/PasswordManager/PasswordManagerFilters';
import PasswordManagerItemsListRow from 'client/PasswordManager/Items/PasswordManagerItemsListRow.vue';
import Toolbar from 'client/PasswordManager/Items/PasswordManagerItemsListToolbar.vue';

const PasswordManagerItemCollection = 'PasswordManagerItemCollection';

const { Column } = Types;

const generateColumns = (itemType) => [
  Column({
    label: 'Nickname',
    dataFieldName: 'nickname',
    sortable: true,
    width: '1fr',
  }),
  Column({
    label: passwordManagerItemFieldsLabelMap[itemType].field1,
    dataFieldName: 'field1',
    sortable: true,
    width: '1fr',
    visible: !!passwordManagerItemFieldsLabelMap[itemType].field1,
  }),
  Column({
    label: passwordManagerItemFieldsLabelMap[itemType].field2,
    dataFieldName: 'field2',
    sortable: true,
    width: '1fr',
    visible: !!passwordManagerItemFieldsLabelMap[itemType].field2,
  }),
];

export default {
  name: 'PasswordManagerItemsList',

  components: {
    ItemListPagination,
    ItemListCollectionWrapper,
    NoSearchResults,
    Toolbar,
  },

  rowsPerPageLocalStorageKey: LocalStorageConsts.passwordManagerItemsRowsPerPage,
  PasswordManagerItemsListRow,
  PasswordManagerItemCollection,

  props: {
    itemType: {
      type: String,
      required: true,
    },
    itemsDefaultFilters: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters(PasswordManagerItemCollection, [
      'refreshKey',
    ]),

    columns() {
      return generateColumns(this.itemType);
    },

    defaultFilters() {
      return [...this.itemsDefaultFilters,
        PasswordManagerFilters.itemType(passwordManagerItemTypeServerId[this.itemType])];
    },
  },

  methods: {
    showEmptyState(slotProps) {
      return !slotProps.loading && (!slotProps.totalCount || slotProps.showEmptyState);
    },
  },
};
</script>

<style scoped>
.itemListWrapper {
  height: var(--pwm-items-item-list-height, 30rem);
}
</style>
